module.exports = "/_next/static/images/facebook-filled-icon-146865b33e81d313a566198db27d6100.svg";